export default __webpack_public_path__ + "static/media/illustration-wood-title.da3e6b50.png";